import { optionTitle_focusedInbox } from './FocusedInboxOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserConfiguration } from 'owa-session-store';

var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
var lazyQuickModule = new LazyModule(() => import('./lazyQuickOption'));
let FocusedInboxOption: LazyOption = createLazyOption(
    {
        key: 'focused',
        titleStringKey: optionTitle_focusedInbox,
        searchTermsStringKey: optionTitle_focusedInbox,
        allowedOptionKeys: ['FocusedInbox'],
        isHidden: () =>
            isFeatureEnabled('tri-inboxPlusDefaultTabs') &&
            getUserConfiguration().UserOptions.InboxPlusTabs !== null,
    },
    lazyFullModule,
    m => m.default,
    lazyQuickModule,
    m => m.default
);
export default FocusedInboxOption;
